// extracted by mini-css-extract-plugin
export default {"badgeIconContainer":"MoneyGuaranteeModal_badgeIconContainer__+U0yc"};